<template>
  <div>
    <NavBar />
    <div class="container">
      <div class="row justify-content-center">
        <div class="col col-md-10 col-lg-10">
          <h1 class="text-center">Bulk Registration Results</h1>
          <ErrorSummary :error="error" />
          <div class="row mt-4 d-print-none">
            <div class="col">
              <div class="card">
                <h5 class="card-header">Bulk Results</h5>
                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <p>
                        Below are the results of your bulk import. If you encounter errors, please try again. If the errors persist, please contact Support.
                      </p>
                      <div class="table-wrap my-2">
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col">Registration Status</th>
                              <th scope="col">Registration ID</th>
                              <th scope="col">Email Address</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="i in results" :key="i.key">
                              <td>
                                <fa :icon="getRowStatusIcon(i)" fixed-width :class="getRowStatusIconClass(i)" />
                                <span class="d-none d-lg-inline">{{ getRowStatusText(i) }}</span>
                              </td>
                              <td :class="getRowClass(i)">{{ i.registrationId || "---" }}</td>
                              <td :class="getRowClass(i)">{{ i.emailAddress || "---" }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="btn-group d-flex justify-content-around" role="group">
                    <button type="button" class="btn btn-primary" @click="done" :disabled="loadingMessage" @keyup.enter="done">
                      <span v-if="loadingMessage" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      {{ loadingMessage ? loadingMessage : "Continue" }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/views/reports/NavBar.vue";
import ErrorSummary from "@/components/ErrorSummary.vue";

export default {
  components: {
    NavBar,
    ErrorSummary,
  },
  props: {
    organizationId: String,
    results: Array,
  },
  data() {
    return {
      loadingMessage: null,
      alertMessage: null,
      error: null,
    };
  },
  methods: {
    reset() {
      this.loadingMessage = null;
      this.alertMessage = null;
      this.error = null;
    },
    getBulkStatus(code) {
      if (!code) return null;
      return this.bulkStatus.find(s => s.code === code);
    },
    getRowClass() {
      return "";
    },
    getRowStatusIcon(row) {
      if (!row.statusCode) return "exclamation-triangle";
      if (row.statusCode == "error") return "times";
      if (row.statusCode == "success") return "check";

      return "exclamation-triangle";
    },
    getRowStatusIconClass(row) {
      if (!row.statusCode) return "";
      if (row.statusCode == "error") return "text-danger";
      if (row.statusCode == "success") return "text-success";

      return "text-warning";
    },
    getRowStatusText(row) {
      if (!row.statusCode) return "";
      if (row.statusCode == "error") return "Error";
      if (row.statusCode == "success") return "Success";

      return "";
    },
    done() {
      this.$router.push(`/organizations/${this.organizationId}/reports`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";

.span-link {
  font-weight: bold;
  text-decoration: underline;

  &:hover {
    cursor: pointer;
  }
}

.strike-through {
  text-decoration: line-through;
}
</style>
